import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6';
import { Button, Flex } from '@chakra-ui/react';

const StepNavigator = ({
  onNext,
  onPrev,
  isNextDisabled,
  isLast,
  isFirst,
  handleSubmit,
  loading,
  isCurrentQuestionAnswered,
}) => (
  <Flex justify='space-between' w={'100%'}>
    <Button size='sm' onClick={onPrev} isDisabled={isFirst} variant='ghost'>
      <FaChevronLeft />
    </Button>
    {!isLast ? (
      <Button size='sm' onClick={onNext} isDisabled={isNextDisabled} variant='ghost'>
        <FaChevronRight />
      </Button>
    ) : (
      <Button
        colorScheme='blue'
        size='md'
        onClick={handleSubmit}
        isLoading={loading}
        disabled={!isCurrentQuestionAnswered}
      >
        Submit
      </Button>
    )}
  </Flex>
);

export default StepNavigator;
